import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import GalleryTile from "@/components/GalleryTile";

export default function SavedPage() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const { data } = await api.get("/me/saved");
        setProjects(data.items);
      } catch (e) {
        console.error(e);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  return (
    <div className="mx-auto max-w-[935px] px-5 md:px-10 pt-6 md:pt-10 pb-20" data-testid="saved-page">
      <div className="mb-6">
        <h1 className="font-heading text-2xl md:text-3xl font-medium text-[color:var(--bda-text)]">Saved</h1>
        <p className="mt-1 text-sm text-[color:var(--bda-text-dim)]">Posts you've bookmarked on this device.</p>
      </div>
      {loading ? (
        <div className="grid grid-cols-3 gap-0.5 md:gap-1">
          {[...Array(6)].map((_, i) => <div key={i} className="aspect-square shimmer" />)}
        </div>
      ) : projects.length === 0 ? (
        <div className="text-center py-20 text-[color:var(--bda-text-dim)] text-sm">
          You haven't saved any posts yet. Tap the bookmark on any post to save it here.
        </div>
      ) : (
        <div className="grid grid-cols-3 gap-0.5 md:gap-1" data-testid="saved-grid">
          {projects.map((p) => <GalleryTile project={p} key={p.id} />)}
        </div>
      )}
    </div>
  );
}
